import React from "react";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="fatal-error page-shell" role="alert">
          <span aria-hidden="true">✦</span>
          <h1>Something spilled behind the scenes.</h1>
          <p>Refresh the page to tidy things up, or return to the storefront.</p>
          <a className="button button--primary" href="/">Return home</a>
        </main>
      );
    }
    return this.props.children;
  }
}

export default AppErrorBoundary;
